import { DragSourceComponent } from './DragSource.component';
import { enhance } from './DragSource.enhancers';

export const DragSource = enhance(DragSourceComponent);
